var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaudeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 6.47998L14.865 6.75998V6.96898L14.725 7.45798L8.78798 8.85498L8.22998 7.46798L14.375 6.47998Z",
    fill: "#FF7043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1551 2.37305L12.8381 2.51605L13.0201 2.74005L13.1931 3.27505L13.1211 3.61705L9.13806 9.06405L7.81006 7.73705L11.4831 2.91705L12.1551 2.37305Z",
    fill: "#FF7043"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71895 1.52219L9.13795 1.24219L9.48695 1.38219L9.83595 1.87219L8.87895 7.62019L8.22895 7.17919L7.94995 6.41019L8.43995 2.08019L8.71895 1.52219Z",
    fill: "#FF7043"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23901 1.614L4.66901 1.064L4.95001 1L5.50801 1.081L5.78301 1.297L7.78701 5.739L8.51101 7.849L7.66301 8.32L4.43201 2.456L4.23901 1.614Z",
    fill: "#FF7043"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.15392 4.66519L2.01392 4.10519L2.43392 3.61719L2.92192 3.68719H3.06192L5.99492 5.85219L6.90292 6.55019L8.15992 7.52819L7.46192 8.71519L6.83292 8.22619L6.41392 7.80719L2.36392 4.94419L2.15392 4.66519Z",
    fill: "#FF7043"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.316 8.29583L1 7.94583V7.63583L1.316 7.52783L4.878 7.73783L8.369 8.01683L8.256 8.71183L1.596 8.36583L1.316 8.29583Z",
    fill: "#FF7043"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41106 11.9312H2.71306L2.43506 11.6112V11.2292L3.62106 10.3912L8.44106 7.32324L8.92806 8.15624L3.41106 11.9312Z",
    fill: "#FF7043"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73804 13.8828L4.45804 13.9528L4.04004 13.7428L4.11004 13.3928L8.23004 7.94678L8.78804 8.71478L5.71604 12.7648L4.73804 13.8828Z",
    fill: "#FF7043"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22999 14.581L8.01999 14.861L7.60099 15.001L7.25199 14.721L7.04199 14.301L8.08999 8.646L8.71899 8.716L8.22999 14.581Z",
    fill: "#FF7043"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7909 13.045V13.603L11.7209 13.813L11.4419 13.953L10.9529 13.887L7.59692 8.89095L8.92792 7.87695L10.0449 9.90195L10.1499 10.635L11.7909 13.045Z",
    fill: "#FF7043"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3979 12.2071L13.4679 12.5561L13.2579 12.8351L13.0479 12.7651L11.8609 11.9271L10.0459 10.3211L8.64893 9.34309L9.06793 8.01709L9.76593 8.43609L10.1859 9.20409L13.3979 12.2071Z",
    fill: "#FF7043"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4899 8.64514L14.2359 8.78514L14.6549 9.06514L14.9339 9.48314V9.78514L14.1659 10.1121L10.2549 9.13414L8.64893 9.06414L9.06793 7.59814L10.1849 8.43614L12.4899 8.64514Z",
    fill: "#FF7043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaudeIcon);
export default __webpack_public_path__ + "static/media/claude_icon.b9315186d9c953cde8fe8dfec991bf04.svg";
export { ForwardRef as ReactComponent };